<p-button [label]="buttonText()" size="small" (onClick)="toggleDarkMode()" />
